import { render, staticRenderFns } from "./NewImport.vue?vue&type=template&id=70e64d38&"
import script from "./NewImport.vue?vue&type=script&lang=ts&"
export * from "./NewImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports